import moment from 'moment';
import { BaseGraphTransformer } from './BaseGraphTransformer';

// eslint-disable-next-line max-len
export class TrainingSummaryAthleteGraphTransformer extends BaseGraphTransformer {
    constructor(params) {
        super(params);
    }

    getProps() {
        this.graphProps.chartType = 'bar';
        this.graphProps.axis.y = {
            min: 0,
            padding: { top: 20, bottom: 0 }
        };
        return this.graphProps;
    }

    transformData(data) {
        const xValues = [];
        const yValues = [];

        for (let i = 0; i < data.length; i++) {
            const formattedDate = moment(data[i].date_completed).format(
                'YYYY-MM-DD'
            );
            const volume = data[i].volume;
            xValues.push(formattedDate);
            yValues.push(volume);
        }

        return {
            graphProps: this.getProps(),
            xValues: ['xValues', ...xValues],
            yValues: ['Volume', ...yValues]
        };
    }
}



// WEBPACK FOOTER //
// ./src/lib/transformer/TrainingSummaryAthleteGraphTransformer.js